<template>
    <div class="row justify-content-center m-2">

      <div class="col-12 text-center p-4" v-if="settings">
        <!-- It's throw error ... -->
        <!-- <h5>{{settings['appointmentgroup.default.frontend.subheading'].value}}</h5> -->

        <div class="font-weight-bold mb-3">Termin stornieren</div>

        <div class="alert alert-danger" v-if="messages.not_found">
          Ihr Termin wurde nicht gefunden oder wurde bereits storniert
        </div>
        <div class="alert alert-success" v-if="messages.canceled">
          Ihr Termin wurde soeben erfolgreich storniert
        </div>
        <div class="mt-3" v-if="selectedTicket">
          Ihr Termin (#{{selectedTicket.id}}):<br/>
          <u>{{selectedTicket.appointment.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedTicket.appointment.date | moment('HH:mm')}} Uhr</u>

          <div class="font-weight-bold mt-3 mb-3">Möchten Sie diesen Termin stornieren?</div>

          <b-button @click="cancelTicket" variant="success">Ja, stornieren</b-button>

          <div class="mt-3 small">Wenn Sie diesen Termin nicht stornieren möchten, schließen Sie einfach dieses Browser-Fenster.</div>
        </div>

      </div>

    </div>

</template>

<script>

    import Vue from 'vue'
    import { BButton } from 'bootstrap-vue'
    const moment = require('moment')
    moment.locale('de')

    Vue.use(require('vue-moment'), {
        moment
    })

    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/v1`

export default {
  name: 'Cancel',
  components: {
   'b-button': BButton
  },
  data () {
    return {
      selectedTicket: null,
      settings: null,
      hash: null,
      messages: {
        not_found: false,
        canceled: false
      }
    }
  },
  async mounted() {

    let uri = window.location.search
    let UrlParams = new URLSearchParams(uri)
    this.hash = UrlParams.get("h");

    const settings = await this.axios.get('/settings?path=appointmentgroup.default.frontend.*')
    this.settings = settings.data

    try {
      const result = await this.axios.get('/tickets/cancel/' + this.hash)
      this.selectedTicket = result.data
    }
    catch (e) {
      this.messages.not_found = true
    }

  },
  methods: {
    async cancelTicket() {
      try {
        await this.axios.post('/tickets/cancel/' + this.hash)
        this.selectedTicket = null
        this.messages.canceled = true
      }
      catch (e) {
        this.selectedTicket = null
        this.messages.not_found = true
      }
    }
  }
}
</script>
<style>
  @import './../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import './../../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  @import './../custom.css';
</style>
